<template>
	<transition name="tuto-info">
		<v-touch @tap="tap_tuto_info()" v-if="game.status && game.tuto_step === step && game.tuto_step != 10" class="tuto-info" :class="['tuto-info-step-' + step, arrow_orientation]">
			<div class="arrow" :class="arrow_orientation"></div>
			<div v-if="!error" class="text" v-html="tuto_texts[lang][step].text"></div>
			<div v-if="error" class="text error" v-html="tuto_texts[lang][step].error"></div>
			<div class="next" v-html="tuto_texts[lang][step].next"></div>
		</v-touch>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex'
import data_tuto_texts from '../../data/tuto.json'

export default {
	name: 'TutoInfo',
	data () {
		return {
			
		}
	},
	props: [ 'step', 'error' ],
	computed: Object.assign(mapGetters([ 'lang', 'game' ]), {
		tapable: function() {
			return (this.step === 1 || this.step === 2 || this.step === 4 || this.step === 6 || this.step === 7 || this.step === 11)
		},
		tuto_texts: function() {
			return data_tuto_texts
		},
		arrow_orientation: function() {
			if (this.step === 8 || this.step === 9) return 'down'
			if (this.step === 2 || this.step === 3 || this.step === 4 || this.step === 5 || this.step === 6) return 'up'
			return 'middle'
		}
	}),
	methods: {
		tap_tuto_info: function() {
			if (this.tapable) {
				sounds.play('tap')
				this.$store.dispatch('next_tuto');
			}
		}
	}
}
</script>

<style lang="stylus">
@import '../../assets/css/app.styl'


.tuto-info-enter-active
	transition 0.25s easeOutQuart
.tuto-info-enter
	opacity 0
	&.up
		transform translate3D(0, 24px, 0)
	&.down
		transform translate3D(0, -24px, 0)

.tuto-info
	position absolute
	width 250px
	padding 8px 16px
	border-radius 4px
	background #fff
	z-index 6
	text-align left
	&.middle
		.arrow
			display none
	&.tuto-info-step-1, &.tuto-info-step-7, &.tuto-info-step-11
		left 50%
		top 50%
		transform translate3D(-50%, -50%, 0)
	&.tuto-info-step-2, &.tuto-info-step-6
		top 80px
		left 50%
		transform translate3D(-50%, 0, 0)
		.arrow
			left calc(50% - 12px)
	&.tuto-info-step-3, &.tuto-info-step-5
		top calc(100% + 8px)
		left 8px
	&.tuto-info-step-4
		top 64px
		left 50%
		transform translate3D(-50%, 0, 0)
		.arrow
			left 50%
			transform translate3D(-50%, 0, 0)
	&.tuto-info-step-8
		bottom calc(100% + 12px)
		right -32px
		.arrow
			right 42px
			transform translate3D(-50%, 0, 0)
	&.tuto-info-step-9
		bottom calc(100% + 12px)
		right -4px
		.arrow
			right 15px
			transform translate3D(-50%, 0, 0)
	.arrow
		content ''
		position absolute
		width: 0;
		height: 0;
		border-style: solid;
		&.up
			top -10px
			border-width: 0 12px 10px 12px;
			border-color: transparent transparent #fff transparent;
		&.down
			bottom -10px
			border-width: 10px 12px 0 12px;
			border-color: #fff transparent transparent transparent;
	.text
		color #333
		font-size 14px
		line-height 18px
		&.error
			color red
		p
			padding 4px 0 2px 0
			strong
				font-weight 400
				color blue
	.next
		margin 8px 0 0 0
		color #aaa
		font-size 10px
		line-height 11px
		text-align right
		.icon
			float right
			margin 0 0 0 4px
			top 1px
			
@media (max-height: 620px)
	.tuto-info
		&.tuto-info-step-2, &.tuto-info-step-6
			top 64px


</style>



// WEBPACK FOOTER //
// src/components/game/TutoInfo.vue